module.exports = __webpack_public_path__ + "static/img/IMG_20170729_205208.f760f94e.jpg";